import { render, staticRenderFns } from "./MenuCartEmpty.vue?vue&type=template&id=6520fafe&scoped=true&"
import script from "./MenuCartEmpty.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MenuCartEmpty.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MenuCartEmpty.vue?vue&type=style&index=0&id=6520fafe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6520fafe",
  null
  
)

export default component.exports